export default __webpack_public_path__ + "static/media/babel.61c7ff23.png";